export default {"src":"/_next/static/media/alternative.031f80cc.svg","height":25,"width":34,"blurWidth":0,"blurHeight":0};